module.exports = __webpack_public_path__ + "dist/introduce_4.599353cf.png";